<template>
    <div class="company-header">
        <div class="company-header-container">
           <div class="logo"  @click="backPlatform"></div>  
            <div class="empty"></div>
            <div class="nav" @click="viewPage">
                <div class="nav-item" :class="$route.name === router.key && 'actived'" v-for="router in routerList"
                    :key="router.key" :data-router="router.key">
                    {{ router.name }}
                </div>
                <div class="nav-item-vip">
                    <img src="@/assets/company-vip.webp" alt="" data-router="rights" />
                </div>
            </div>
            <div class="company-info">
                <el-dropdown>
                    <div class="company-info-content">
                        <el-avatar :size="32" :src="basicInfo.avatar"></el-avatar>
                        <span class="el-dropdown-link">{{ basicInfo.staff_name }} </span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <div @click="clickMenu('website')">前往官网</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="clickMenu('order')">我的订单</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="clickMenu('changePassword')">修改密码</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="clickMenu('logout')">退出</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import companyApi from '@/api/company'
import commonApi from '@/api/common'
export default {
    name: 'companyHeader',
    data() {
        return {
            basicInfo: {},
            routerList: [
                {
                    name: '首页',
                    key: 'companyHome',
                },
                {
                    name: '面试记录',
                    key: 'interviewRecord',
                },
            ],
            mainClient: {
                user: {
                    development: 'https://dev-ai.zilieai.com',
                    production: 'https://ai.zilie.com',
                },
                company: {
                    // development: 'http://localhost:8080',
                    development: 'https://dev-ai.zilieai.com',
                    production: 'https://ai.zilie.com',
                },
            },
        }
    },
    mounted() {
        this.getProfile()
        // if(localStorage.getItem('user_info')) {
        //     this.basicInfo = JSON.parse(localStorage.getItem('user_info'))
        // } else {
        //     this.getProfile()
        // }
    },
    methods: {
        getProfile() {
            companyApi.getProfile().then((res) => {
                if (res.code === 0) {
                    this.basicInfo = res.data
                    localStorage.setItem('user_info', JSON.stringify(res.data))
                }
            })
        },
        viewPage(e) {
            this.$router.push({
                name: e.target.dataset.router,
            })
        },
        clickMenu(type) {
            if (type === 'logout') {
                console.log('logout')
            }
            switch (type) {
                case 'website':
                    window.open('https://zilie.com', '_blank')
                    break
                case 'order':
                    this.$router.push({
                        name: 'order',
                    })
                    break
                case 'changePassword':
                    this.$router.push({
                        name: 'changePassword',
                    })
                    break
                case 'logout':
                    commonApi.logout().then((res) => {
                        if (res.code === 0) {
                            localStorage.clear()
                            sessionStorage.removeItem('openFreeMenu')
                            this.$store.dispatch('chat/logout')
                            this.$message.info('退出成功')
                            this.$router.replace({
                                name: 'newIndex'
                            })
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    break
            }
        },
        backPlatform() {
            this.$router.push({
                name: 'newIndex'
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.company-header {
    width: 100%;

    //height: 64px;
    .company-header-container {
        width: 1200px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo {
            width: 168px;
            height: 48px;
            background: url('@/assets/login-logo.webp') no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
        }

        .empty {
            flex: 1;
        }

        .nav {
            min-width: 300px;
            height: 40px;
            display: flex;
            align-items: center;
            margin-right: 10px;

            .nav-item {
                width: 140px;
                height: 40px;
                margin-left: 20px;
                line-height: 40px;
                cursor: pointer;
                padding: 0 10px;
                background: rgba(255, 255, 255, 0.5);
                border-radius: 0px 0px 0px 0px;
                text-align: center;
                clip-path: polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px);
            }

            .nav-item-vip {
                width: 100px;
                height: 32px;
                margin: 0 20px;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .actived {
                color: #3264fa;
            }
        }

        .company-info {
            width: 120px;
            height: 32px;

            .company-info-content {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;

                .el-dropdown-link {
                    margin-left: 10px;
                }
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .company-header {
        height: auto;
        max-height: 106px;
        min-height: 64px;
    }

    .company-header .company-header-container {
        flex-wrap: wrap;
        padding: 10px 15px;
    }

    .company-header .company-header-container .logo {
        width: 120px;
        height: 36px;
    }

    .company-header .company-header-container .nav {
        order: 3;
        width: 100%;
        min-width: auto;
        margin-top: 10px;
        margin-right: 0;
        justify-content: center;
    }

    .company-header .company-header-container .nav .nav-item {
        width: auto;
        padding: 0 15px;
        margin: 0 5px;
        font-size: 14px;
    }

    .company-header .company-header-container .nav .nav-item-vip {
        width: 80px;
        height: 28px;
        margin: 0 5px;
    }

    .company-header .company-header-container .company-info {
        width: auto;
    }
}

@media (max-width: 480px) {
    .company-header .company-header-container {
        padding: 8px 10px;
    }

    .company-header .company-header-container .logo {
        width: 100px;
        height: 30px;
    }

    .company-header .company-header-container .nav .nav-item {
        padding: 0 10px;
        font-size: 13px;
        height: 36px;
        line-height: 36px;
    }

    .company-header .company-header-container .nav .nav-item-vip {
        width: 70px;
        height: 24px;
    }

    .company-header .company-header-container .empty {
        flex: 0 0 10px;
    }
}
</style>
